export const minAmountLimit = 350
export const maxSBPAmountLimit = '14 950'
export const maxLSAmountLimit = '14 950'
